import { render, staticRenderFns } from "./copy-url.vue?vue&type=template&id=6f6c890b&scoped=true&"
import script from "./copy-url.vue?vue&type=script&lang=js&"
export * from "./copy-url.vue?vue&type=script&lang=js&"
import style0 from "./copy-url.vue?vue&type=style&index=0&id=6f6c890b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6c890b",
  null
  
)

export default component.exports